<script setup lang="ts">
import type { NuxtError } from '#app';

const config = useRuntimeConfig();

const colorMode = useColorMode();
const { $sentryClientSide } = useNuxtApp();

const { error } = defineProps({
  error: Object as () => NuxtError,
});

const errorType = computed(() =>
  error.statusCode < 500 ? 'client' : 'server',
);

onMounted(() => {
  $sentryClientSide.setTag('status-code', error.statusCode);
  $sentryClientSide.captureException(error);
});
</script>

<template>
  <div class="w-screen overflow-x-hidden overflow-y-hidden">
    <LoadingTopBar />
    <NuxtRouteAnnouncer />
    <UApp>
      <Navigation isErrorPage>
        <div v-if="error" class="w-full h-screen flex flex-col m-24 gap-2">
          <NuxtImg class="size-20" src="/error500@2x.png" />
          <h2 class="font-error">{{ errorType === 'client' ? 'Page not found' : 'Something went wrong'  }}</h2>
          <p v-if="errorType === 'server'">Please try again in a few moments.</p>
          <br />
          <h3>Back to <UButton class="p-0 pl-0.5" size="xl" variant="link" link to="/app/projects">My Projects</UButton></h3>
          <code v-if="config.public.env === 'development'" class="my-4">
            {{ JSON.stringify(error) }}
          </code>
        </div>
      </Navigation>
    </UApp>
  </div>
</template>

<style scoped>
@reference "./assets/css/main.css";

.h-screen {
  height: 80svh;
}

.font-error {
  @apply font-body-l-strong;
  font-size: 2.5rem;
}
</style>
